import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const FullPageLoader = ({ loading }) => (
  <Backdrop
    sx={{
      color: "#fff",
      zIndex: (theme) => theme.zIndex.drawer + 1,
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    }}
    open={loading}
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);

export default FullPageLoader;
